
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#1CA1F2","d":"M14.4 1.534a5.9 5.9 0 0 1-1.697.465 2.96 2.96 0 0 0 1.3-1.634 5.918 5.918 0 0 1-1.877.717 2.957 2.957 0 0 0-5.035 2.694A8.387 8.387 0 0 1 1.003.689a2.958 2.958 0 0 0 .913 3.945 2.942 2.942 0 0 1-1.337-.37c-.032 1.369.949 2.65 2.37 2.934-.416.113-.872.14-1.335.05A2.957 2.957 0 0 0 4.374 9.3 5.94 5.94 0 0 1 0 10.524a8.363 8.363 0 0 0 4.529 1.327c5.485 0 8.584-4.632 8.397-8.787a6.015 6.015 0 0 0 1.474-1.53z"}})])
          )
        }
      }
    